/** Binary step between adjacent units; S3 and the backend caps both count in KiB. */
const STEP = 1024;

const UNITS = ['B', 'KB', 'MB', 'GB'] as const;

/**
 * Format a byte count for display next to an uploaded file, e.g. `4.2 MB`.
 *
 * Whole bytes are rendered without a decimal - a fractional byte does not
 * exist - and every larger unit to one decimal place. Pure.
 *
 * @param bytes Size in bytes. Negative, NaN and Infinity all render as `0 B`
 *   rather than throwing, because this only ever feeds a label.
 * @returns The formatted size, always a non-empty string.
 */
export function formatBytes(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes <= 0) return `0 ${UNITS[0]}`;

  let value = bytes;
  let unitIndex = 0;
  while (value >= STEP && unitIndex < UNITS.length - 1) {
    value /= STEP;
    unitIndex += 1;
  }

  return unitIndex === 0
    ? `${Math.round(value)} ${UNITS[0]}`
    : `${value.toFixed(1)} ${UNITS[unitIndex]}`;
}
